/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import type ForgeProjectSettingsPageType from '@jira/spa-apps__forge-project-settings/src/ForgeProjectSettingsPageShellWithAnalytics.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyForgeProjectSettingsPage: LazyComponent<React.ComponentType<Record<any, any>>> =
	lazyForPaint<typeof ForgeProjectSettingsPageType>(
		() =>
			import(
				/* webpackChunkName: "async-forge-spa-project-settings", jiraSpaEntry: "async-forge-spa-project-settings" */ '@jira/spa-apps__forge-project-settings/src/ForgeProjectSettingsPageShellWithAnalytics.tsx'
			),
	);

export const ForgeProjectSettingsPage = (): React.JSX.Element => (
	<LazyPage
		Page={LazyForgeProjectSettingsPage}
		pageId="forge-spa-project-settings"
		shouldShowSpinner
	/>
);

export default ForgeProjectSettingsPage;
